import React, { useContext, useState, FC } from "react";
import { Form as FinalForm, Field } from "react-final-form";
import { Container, Form, Button } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import {
  combineValidators,
  composeValidators,
  hasLengthLessThan,
  matchesPattern,
  hasLengthGreaterThan,
} from "revalidate";
import { toast } from "react-toastify";
import { RootStoreContext } from "../../app/stores/rootStore";
import TextInput from "../../app/common/form/TextInput";
import { IResendMailForm } from "../../app/models/trackDocument";

const validate = combineValidators({
  mail: composeValidators(
    matchesPattern(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/)({
      message: "Por favor digite un Email valido",
    }),
    hasLengthGreaterThan(5)({
      message: "El Mail debe tener al menos 6 caracteres",
    }),
    hasLengthLessThan(257)({
      message: "El Mail debe tener máximo 256 caracteres",
    }),
  )(),
  ccEmail: composeValidators(
    matchesPattern(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/)({
      message: "Por favor digite un Email valido",
    }),
    hasLengthGreaterThan(5)({
      message: "El Mail debe tener al menos 6 caracteres",
    }),
    hasLengthLessThan(257)({
      message: "El Mail debe tener máximo 256 caracteres",
    }),
  )(),
  subject: composeValidators(
    hasLengthGreaterThan(5)({
      message: "El asunto debe tener al menos 6 caracteres",
    }),
    hasLengthLessThan(257)({
      message: "El asunto debe tener máximo 256 caracteres",
    }),
  )(),
});

interface IProps {
  documentsId: string[];
  clearSelected: () => void;
}

const ResendMail: FC<IProps> = ({ documentsId, clearSelected }) => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { resendBulkMail } = rootStore.trackDocumentStore;
  const { loading } = rootStore.buttonLoadingStore;

  const [resendMailForm] = useState<IResendMailForm>({
    contact: "",
    mail: "",
    ccEmail: "",
  });

  const newDocsIds = documentsId.map((id) => id);

  const handleFinalFormSubmit = (values: IResendMailForm) => {
    if (newDocsIds.length > 0) {
      resendBulkMail(values, newDocsIds);
      clearSelected();
    } else toast.error("No ha seleccionado ningún correo");
  };

  return (
    <div className="tabContentStyle">
      <FinalForm
        validate={validate}
        initialValues={resendMailForm}
        onSubmit={handleFinalFormSubmit}
        render={({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <Container textAlign="justified">
              <label>Asunto de correos (opcional)</label>
              <Field
                name="subject"
                placeholder="Envío de factura electrónica"
                component={TextInput}
              />
              <label>Mail (opcional)</label>
              <Field
                name="mail"
                placeholder="ej. jhon_doe@mail.com"
                component={TextInput}
              />
              <span className="resend-mails-footnote">
                Si no se especifica un asunto o mail, se usarán los datos por defecto.
              </span>
              <label>CC (opcional)</label>
              <Field
                name="ccEmail"
                placeholder="ej. jhon_doe@mail.com"
                component={TextInput}
              />
              <Button
                loading={loading}
                disabled={loading}
                className="ui primary button"
                color="blue"
                type="submit"
                content="Enviar"
              />
            </Container>
          </Form>
        )}
      />
    </div>
  );
};

export default observer(ResendMail);
